export default __webpack_public_path__ + "static/media/threeicon3.9b14ed9a.png";